import {ReactComponent as EyeIcon} from "./eye.svg";

const Eyeicon = () => {
    return (
        <div><EyeIcon className='icon' /></div>
    )
}
export default Eyeicon
